export default {
  indexEndpoint: '/design/service',
  storeEndpoint: '/design/service',
  editEndpoint: '/design/service/',
  updateEndpoint: '/design/service/',
  deleteEndpoint: '/design/service/',
}
